import React from 'react';
import {
  ChatBubbleLeftIcon,
  CheckIcon,
  EnvelopeIcon,
  PencilIcon,
  PlusIcon,
} from '@heroicons/react/16/solid';
import { ActivityEvent } from './activityEvents';
import { formatRelativeTime, formatTimestamp } from '../../utils/dateUtils';

const eventIcon: Record<ActivityEvent['kind'], React.ReactNode> = {
  created: <PlusIcon className="h-3 w-3" />,
  notified: <EnvelopeIcon className="h-3 w-3" />,
  responded: <ChatBubbleLeftIcon className="h-3 w-3" />,
  resolved: <CheckIcon className="h-3 w-3" />,
  completed: <CheckIcon className="h-3 w-3" />,
  edited: <PencilIcon className="h-3 w-3" />,
};

/**
 * One record moment on an activity timeline (created, resolved, last
 * edited …): a small icon on the timeline's line, then who and when.
 * Shared by the violation and work-order timelines. Renders the `<li>`;
 * the caller owns the `<ol>` and its line.
 */
export const ActivityEventRow: React.FC<{
  event: ActivityEvent;
  /** Display name for the event's actor, when it has one. */
  actorName: (actorId: string) => string;
}> = ({ event, actorName }) => (
  <li className="relative flex items-center gap-3">
    <span className="relative z-10 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-panel text-fg-muted ring-1 ring-line">
      {eventIcon[event.kind]}
    </span>
    <p
      className="min-w-0 text-[13px] text-fg-muted"
      title={
        event.kind === 'edited'
          ? 'Only the most recent edit is recorded; earlier changes are not kept.'
          : undefined
      }
    >
      {event.actorId && (
        <span className="font-medium text-fg-secondary">
          {actorName(event.actorId)}{' '}
        </span>
      )}
      {event.text}
      <span aria-hidden> · </span>
      <time dateTime={event.at} title={formatTimestamp(event.at)}>
        {formatRelativeTime(event.at)}
      </time>
    </p>
  </li>
);

export default ActivityEventRow;
